import { useCallback, useEffect, useState } from 'react'

import { OwnedToken } from 'types/entities'

import { useRequest } from 'hooks/api'

import { useAccount, usePublicClient } from 'wagmi'

import { fetchTokens } from 'services/fetchTokens'

export function useCustomerTokens() {
  const { chain } = usePublicClient()
  const { address } = useAccount()

  const [tokenList, setTokenList] = useState<OwnedToken[] | null>(null)

  useEffect(() => {
    if (address) {
      request.call()
    }
  }, [address, chain.id])

  const onFetchTokens = useCallback(async () => {
    if (!address) {
      return []
    }
    const tokens = await fetchTokens(address, chain)

    setTokenList(tokens)
    return tokens
  }, [address, chain])

  const request = useRequest<OwnedToken[]>(onFetchTokens)

  const addToken = (token: OwnedToken) => {
    setTokenList((_tokens) => [token, ...(_tokens || [])])
  }

  return {
    tokenList,
    addToken,
    isError: request.isError,
    isLoading: request.isLoading,
    errorMessage: request.errorMessage,
  }
}
